
<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="accountList"
      sort-by="uid"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar
          flat
          color="white"
        >
          <v-toolbar-title>帳戶資料</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                新增會員
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="accountForm">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.uid"
                          :rules="[errorMessage.required]"
                          label="登入ID"
                        />
                      </v-col>
                      <v-col
                        v-show="editedItem.editpw"
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.pw"
                          :rules="[errorMessage.required]"
                          :type="'password'"
                          label="登入密碼"
                        />
                      </v-col>
                      <v-col
                        v-show="editedItem.editpw"
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.checkpw"
                          :rules="[errorMessage.confirmPassword]"
                          :type="'password'"
                          label="再次密碼確認"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-select
                          v-model="editedItem.superuser"
                          :rules="[errorMessage.selectReq]"
                          :items="levelList"
                          label="等級"
                          solo
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-select
                          v-model="editedItem.fieldValue"
                          :items="fieldList"
                          label="場域"
                          solo
                          multiple
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.create_dat"
                          :rules="[errorMessage.required]"
                          disabled
                          label="建檔日期"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.cust_id"
                          :rules="[errorMessage.required]"
                          disabled
                          label="所屬業務"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  取消
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  存檔
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
        <v-icon
          small
          @click="resetItem(item)"
        >
          mdi-refresh
        </v-icon>
      </template>
      <template #no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      v-model="snackbar"
      top
      :color="snackbarcolor"
      multi-line="multi-line"
      timeout="2000"
    >
      {{ text }}
      <template #action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
var md5 = require("md5");
import Cookies from "js-cookie";

export default {
  components: {},
  data: () => ({
    snackbarcolor: "success",
    snackbar: false,
    text: "更新成功",
    accountList: [],
    dialog: false,
    headers: [
      {
        text: "cust_id",
        align: "start",
        sortable: false,
        value: "cust_id",
      },
      { text: "uid", value: "uid" },
      { text: "Superuser", value: "superuser" },
      { text: "Create_dat", value: "create_dat" },
      { text: "Login_dat", value: "login_dat" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      cust_id: "",
      uid: "",
      superuser: "",
      create_dat: moment().format("YYYY-MM-DD HH:mm:ss"),
      login_dat: "",
      pw: "",
      chkpw: "",
      editpw: true,
    },
    defaultItem: {
      cust_id: "",
      uid: "",
      superuser: "",
      create_dat: moment().format("YYYY-MM-DD HH:mm:ss"),
      login_dat: "",
      pw: "",
      chkpw: "",
      editpw: true,
    },
    levelList: [],
    fieldList: [],
  }),
  computed: {
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    formTitle() {
      return this.editedIndex === -1 ? "新增會員" : "編輯會員";
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
    errorMessage() {
      return {
        required: (value) => !!value || "必填.",
        selectReq: [(v) => !!v || "必填."],

        confirmPassword: (v) => v === this.editedItem.pw || "密碼不相符",
      };
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
      if (val) {
        if (this.editedItem != null && this.editedItem.superuser == "") {
          this.defaultItem.cust_id = this.loginInfo.cust_id;
          this.editedItem.cust_id = this.loginInfo.cust_id;
        }
      }
    },
  },
  created: function () {
    Cookies.set("url", "/AccountList");

    this.initialize();
  },
  methods: {
    initialize() {
      this.defaultItem.cust_id = this.loginInfo.cust_id;
      this.levelList = [];
      this.levelList.push("Admin");
      this.levelList.push("End User");
      this.levelList.push("CNC Admin");
      this.levelList.push("CNC End User");
      this.levelList.push("Solar Admin");
      this.levelList.push("Solar User");

      this.fieldList = [];
      let nform = {
        cust_id: this.loginInfo.cust_id,
      };
      this.$store
        .dispatch("exec_cust_gateway_000", nform)
        .then((res) => {
          this.fieldList = this.exec_cust_gateway_000.map(function (item) {
            return item.gw_desc;
          });
        })
        .catch((err) => {
          console.log(err);
        });
      nform = {
        cust_id: this.loginInfo.cust_id,
      };
      let that = this;
      this.$store
        .dispatch("exec_cust_uid_005", nform)
        .then((res) => {
          this.accountList = res.map(function (item) {
            let admintext = "";
            if (item.superuser == 1) {
              admintext = "Admin";
            } else if (item.superuser == 0) {
              admintext = "End User";
            } else if (item.superuser == 3) {
              admintext = "CNC Admin";
            } else if (item.superuser == 4) {
              admintext = "CNC End User";
            } else if (item.superuser == 5) {
              admintext = "Solar Admin";
            } else if (item.superuser == 6) {
              admintext = "Solar User";
            }

            // 3
            //cn  admin
            // 4
            // cnc user

            let editpw = false;
            if (that.loginInfo.uid == item.uid) {
              editpw = true;
            }

            let obj = {
              cust_id: that.loginInfo.cust_id,
              uid: item.uid,
              superuserval: item.superuser,
              superuser: admintext,
              create_dat: item.create_dat,
              login_dat: item.login_dat,
              editpw: editpw,
            };

            return obj;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editItem(item) {
      this.editedIndex = this.accountList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;

      if (this.$refs["accountForm"] != null) {
        let valid = this.$refs["accountForm"].resetValidation();
      }
      let nform = {
        cust_id: this.loginInfo.cust_id,
        uid: item.uid,
      };
      let that = this;
      let editItemvalue = [];
      this.$store
        .dispatch("exec_uid_gateway_000", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              let gw_no = res[i].gw_no;

              let dev = that.fieldListFindByip_adrs(gw_no);
              if (dev != null && dev.length > 0) {
                editItemvalue.push(dev[0].gw_desc);
              }
            }
            that.editedItem.fieldValue = editItemvalue;
            that.$forceUpdate();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteItem(item) {
      const index = this.accountList.indexOf(item);
    
      if (confirm("Are you sure you want to delete this item?"))
      {
        this.accountList.splice(index, 1);

        let nform = {
        cust_id: this.loginInfo.cust_id,
        uid: item.uid,
      };
      let that = this;
      let editItemvalue = [];
      this.$store
        .dispatch("exec_cust_uid_007", nform)
        .then((res) => {
          this.snackbar = true;
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
        });


      }
    },
    resetItem(item) {
      let nform = {
        cust_id: this.loginInfo.cust_id,
        uid: item.uid,
      };
      let that = this;
      let editItemvalue = [];
      this.$store
        .dispatch("exec_cust_uid_003", nform)
        .then((res) => {
          this.snackbar = true;
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.editedIndex > -1) {
        let valid = this.$refs["accountForm"].validate();
        if (this.loginInfo.uid != this.editedItem.uid) {
          valid = true;
        }

        if (valid) {
          let rights = 0;
          if (this.editedItem.superuser == "Admin") {
            rights = 1;
          } else if (this.editedItem.superuser == "End User") {
            rights = 0;
          } else if (this.editedItem.superuser == "CNC Admin") {
            rights = 3;
          } else if (this.editedItem.superuser == "CNC End User") {
            rights = 4;
          } else if (this.editedItem.superuser == "Solar Admin") {
            rights = 5;
          } else if (this.editedItem.superuser == "Solar User") {
            rights = 6;
          }

          let nform = {
            cust_id: this.loginInfo.cust_id,
            uid: this.editedItem.uid,
            rights: rights,
          };
          let that = this;
          this.$store
            .dispatch("exec_cust_uid_001", nform)
            .then((res) => {
              if (res.trim() == "done") {
                let ips = "";
                if (
                  this.editedItem.fieldValue != null &&
                  this.editedItem.fieldValue.length > 0
                ) {
                  for (var i = 0; i < this.editedItem.fieldValue.length; i++) {
                    let dev = that.fieldListFindByName(
                      this.editedItem.fieldValue[i]
                    );

                    if (dev != null && dev.length > 0) {
                      if (ips == "") {
                        ips = dev[0].ip_adrs;
                      } else {
                        ips += ";" + dev[0].ip_adrs;
                      }
                    }
                  }
                }

                nform = {
                  cust_id: that.loginInfo.cust_id,
                  uid: that.editedItem.uid,
                  ip_adrs: ips,
                };

                that.$store
                  .dispatch("exec_uid_gateway_003", nform)
                  .then((res) => {
                    if (this.editedItem.editpw) {
                      let psw = md5(that.editedItem.pw);

                      nform = {
                        cust_id: that.loginInfo.cust_id,
                        uid: that.editedItem.uid,
                        psw: psw,
                      };
                      that.$store
                        .dispatch("exec_cust_uid_004", nform)
                        .then((res) => {
                          that.text = "success";
                          that.snackbarcolor = "success";

                          that.snackbar = true;
                          that.close();
                          that.initialize();
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    } else {
                      that.text = "success";
                      that.snackbarcolor = "success";

                      that.snackbar = true;
                      that.close();
                      that.initialize();
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                that.snackbarcolor = "error";
                that.text = "update error";
                that.snackbar = true;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        if (this.$refs["accountForm"].validate()) {
          let rights = 0;
          if (this.editedItem.superuser == "Admin") {
            rights = 1;
          } else if (this.editedItem.superuser == "End User") {
            rights = 0;
          } else if (this.editedItem.superuser == "CNC Admin") {
            rights = 3;
          } else if (this.editedItem.superuser == "CNC End User") {
            rights = 4;
          } else if (this.editedItem.superuser == "Solar Admin") {
            rights = 5;
          } else if (this.editedItem.superuser == "Solar User") {
            rights = 6;
          }

          let psw = md5(this.editedItem.pw);

          let nform = {
            cust_id: this.loginInfo.cust_id,
            uid: this.editedItem.uid,
            rights: rights,
            create_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            psw: psw,
          };
          let that = this;
          this.$store
            .dispatch("exec_cust_uid_002", nform)
            .then((res) => {
              let ips = "";
              if (
                this.editedItem.fieldValue != null &&
                this.editedItem.fieldValue.length > 0
              ) {
                for (var i = 0; i < this.editedItem.fieldValue.length; i++) {
                  let dev = that.fieldListFindByName(
                    this.editedItem.fieldValue[i]
                  );

                  if (dev != null && dev.length > 0) {
                    if (ips == "") {
                      ips = dev[0].ip_adrs;
                    } else {
                      ips += ";" + dev[0].ip_adrs;
                    }
                  }
                }
              }

              nform = {
                cust_id: that.loginInfo.cust_id,
                uid: that.editedItem.uid,
                ip_adrs: ips,
              };

              that.$store
                .dispatch("exec_uid_gateway_003", nform)
                .then((res) => {
                  that.snackbar = true;
                  that.close();
                  that.initialize();
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    fieldListFindByip_adrs(val) {
      let arr = this.exec_cust_gateway_000.filter(function (
        item,
        index,
        array
      ) {
        return item.ip_adrs == val;
      });

      return arr;
    },
    fieldListFindByName(val) {
      let arr = this.exec_cust_gateway_000.filter(function (
        item,
        index,
        array
      ) {
        return item.gw_desc == val;
      });

      return arr;
    },
  },
};
</script>

<style>
</style>